import isTruthy from './is-truthy'

const onlyIfDefined = (value, callback) => (isTruthy(value) ? callback(value) : null)

export default onlyIfDefined
